import { Component, OnInit } from '@angular/core';
import { NotificationService } from '@core/services/notification.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { GestaoAlertasService } from '../services/gestao-alertas.service';
import { AcoesModalEnum } from '@modules/gestao-alertas/models/alerta';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-excluir-inativar-alerta-dialog',
  templateUrl: './excluir-inativar-alerta-dialog.component.html',
  styleUrls: ['./excluir-inativar-alerta-dialog.component.scss']
})
export class ExcluirInativarAlertaDialogComponent implements OnInit {

  alerta: any;
  acaoType: any;
  tipoAcao: string

  funcaoModal: any;
  textModal: string;

  acoesModalEnum = AcoesModalEnum;


  private acaoSubject = new BehaviorSubject<{ acao: string, funcao: () => void } | null>(null);
  acao$ = this.acaoSubject.asObservable();


  constructor(
    public activeModal: NgbActiveModal,
    public notificationService: NotificationService,
    public gestaoAlertasService: GestaoAlertasService
  ) { }

  ngOnInit() {
    this.atualizarAcao();
  }


  private atualizarAcao(): void {
    let acaoData;

    switch (this.acaoType) {
      case AcoesModalEnum.Excluir:
        acaoData = { acao: 'excluir', funcao: () => this.excluirAlerta() };
        break;
      case AcoesModalEnum.Inativar:
        acaoData = { acao: 'inativado', funcao: () => this.activeInactiveAlert(this.alerta) };
        break;
      case AcoesModalEnum.Ativar:
        acaoData = { acao: 'reativado', funcao: () => this.activeInactiveAlert(this.alerta) };
        break;
    }

    this.acaoSubject.next(acaoData);
    this.funcaoModal = this.acaoSubject.value.funcao;
    this.textModal = this.acaoSubject.value.acao;
  }


  excluirAlerta() {
    this.gestaoAlertasService.excluirAlerta(this.alerta.id).subscribe((data: any) => {
      this.notificationService.success('Alerta excluído com sucesso!');
      this.fecharModal();
    })
  }

  activeInactiveAlert(element) {
    this.gestaoAlertasService.ativarInativarAlerta(element.id, !element.active).subscribe(() => {
      let msg = `Alerta ${this.textModal} com sucesso!`
      this.notificationService.success(msg);
      this.fecharModal();
    })
  }

  fecharModal(value?): void {
    this.activeModal.close(value);
  }

}
